export default {
  methods: {
    getMyTypeClass: function(theType) {
      if (theType) {
        if(theType.name == "Fertilizer") {
          return "type--fer"
        } else if (theType.name == "Phytosanitary") {
          return "type--phy"
        } else {
          return "type--bio"
        }
      } else {
        return "type--unk"
      }
    },
    getMyColorRate: function(theRate) {
      var rangeColours = ["#DD7814", "#EEBB88", "#A4A8AA", "#A8CCDD", "#5199BC"];
      return rangeColours[theRate - 1];
    }
  },
  filters: {
    gheomizeDateFirst: function(theDate) {
      var thisDate = moment(theDate, "YYYY-MM-DD HH:mm:ss");
      return moment(thisDate).format("DMMM");
    },
    gheomizeDateSecond: function(theDate) {
      var thisDate = moment(theDate, "YYYY-MM-DD HH:mm:ss");
      return moment(thisDate).format("YYYY");
    },
    fixType: function(theType) {
      if(theType == null){
        return "Unknown"
      } else {
        return theType.name
      }
    }
  }
}